import {
	URL_DELETE_ADVISER_TO_CHALLENGUE,
	URL_DELETE_CHALLENGUE,
	URL_DELETE_INVITATION,
	URL_GET_ALL_CHALLENGES,
	URL_GET_CHALLENGUE,
	URL_GET_GET_CONFIG_FOR_CHALLENGUE,
	URL_GET_GET_CONFIG_FOR_INVESTOR_CHALLENGUE,
	URL_GET_INVITATIONS_FOR_CHALLENGUE,
	URL_GET_LAST_USER_CHALLENGES,
	URL_GET_USER_CHALLENGES,
	URL_PATCH_ADD_ADVISER_TO_CHALLENGUE,
	URL_PATCH_CHALLENGUE,
	URL_PATCH_CHALLENGUE_ACCELERATOR_CONFIG,
	URL_PATCH_CHALLENGUE_COMPANY_CONFIG,
	URL_PATCH_CHALLENGUE_INCUBATOR_CONFIG,
	URL_PATCH_CHALLENGUE_INSTITUTION_CONFIG,
	URL_PATCH_INVITATION,
	URL_POST_ADD_USER_PROFILES_TO_CHALLENGE,
	URL_POST_CHALLENGUE,
	URL_POST_SEND_INVITATION_EMAIL,
	URL_POST_SEND_INVITATIONS,
} from "./urls";

import {
	defaultError,
	getDeleteHeaderWithCredentials,
	getFileHeaderWithCredentials,
	getGetHeaderWithCredentials,
	getPatchHeaderWithCredentials,
	getPostHeaderWithCredentials,
} from "api/config";

export function getChallengesAPI(accessToken: string, page: number, parameters?: any) {
	return function () {
		return fetch(URL_GET_ALL_CHALLENGES(page, parameters), getGetHeaderWithCredentials(accessToken))
			.then((response) => response.json())
			.catch((error) => {
				if (error.name === "SyntaxError") {
					return {};
				}

				return defaultError();
			});
	};
}

export function getMyChallengesAPI(accessToken: string, page: number, perPage: number = 20, parameters?: any) {
	return function () {
		return fetch(URL_GET_USER_CHALLENGES(page, perPage, parameters), getGetHeaderWithCredentials(accessToken))
			.then((response) => response.json())
			.catch((error) => {
				if (error.name === "SyntaxError") {
					return {};
				}

				return defaultError();
			});
	};
}

export function getMyLastChallengesAPI(accessToken: string) {
	return function () {
		return fetch(URL_GET_LAST_USER_CHALLENGES, getGetHeaderWithCredentials(accessToken))
			.then((response) => response.json())
			.catch((error) => {
				if (error.name === "SyntaxError") {
					return {};
				}

				return defaultError();
			});
	};
}

export function getInvitationsForChallengeAPI(slug: string, accessToken: string) {
	return function () {
		return fetch(URL_GET_INVITATIONS_FOR_CHALLENGUE(slug), getGetHeaderWithCredentials(accessToken))
			.then((response) => response.json())
			.catch((error) => {
				if (error.name === "SyntaxError") {
					return {};
				}

				return defaultError();
			});
	};
}

export function getChallengeAPI(slug: string, accessToken: string = "") {
	return function () {
		return fetch(URL_GET_CHALLENGUE(slug), getGetHeaderWithCredentials(accessToken))
			.then((response) => response.json())
			.catch((error) => {
				if (error.name === "SyntaxError") {
					return {};
				}

				return defaultError();
			});
	};
}

export function getConfigForChallengeAPI(id: string, accessToken: string = "") {
	return function () {
		return fetch(URL_GET_GET_CONFIG_FOR_CHALLENGUE(id), getGetHeaderWithCredentials(accessToken))
			.then((response) => response.json())
			.catch((error) => {
				if (error.name === "SyntaxError") {
					return {};
				}

				return defaultError();
			});
	};
}

export function newChallengeAPI(data: object, accessToken: string) {
	return function () {
		return fetch(URL_POST_CHALLENGUE, getPostHeaderWithCredentials(data, accessToken))
			.then((response) => response.json())
			.catch((error) => {
				if (error.name === "SyntaxError") {
					return {};
				}

				return defaultError();
			});
	};
}

export function sendInvitationAPI(data: any, slugChallenge: string, profileSlug: string, accessToken: string) {
	return function () {
		return fetch(URL_POST_SEND_INVITATIONS(slugChallenge, profileSlug), getPostHeaderWithCredentials(data, accessToken))
			.then((response) => response.json())
			.catch((error) => {
				if (error.name === "SyntaxError") {
					return {};
				}

				return defaultError();
			});
	};
}

export function sendInvitationEmailAPI(data: any, accessToken: string) {
	return function () {
		return fetch(URL_POST_SEND_INVITATION_EMAIL(), getPostHeaderWithCredentials(data, accessToken))
			.then((response) => response.json())
			.catch((error) => {
				if (error.name === "SyntaxError") {
					return {};
				}

				return defaultError();
			});
	};
}

// Data is the Excel's file.
export function addUserProfileToChallengeAPI(data: FormData, contentType: string, slug: string, accessToken: string) {
	return function () {
		return fetch(
			URL_POST_ADD_USER_PROFILES_TO_CHALLENGE(slug),
			getFileHeaderWithCredentials(data, contentType, accessToken),
		)
			.then((response) => response.json())
			.catch((error) => {
				if (error.name === "SyntaxError") {
					return {};
				}

				return defaultError();
			});
	};
}

export function updateChallengeAPI(data: object, slug: string, accessToken: string) {
	return function () {
		return fetch(URL_PATCH_CHALLENGUE(slug), getPatchHeaderWithCredentials(data, accessToken))
			.then((response) => response.json())
			.catch((error) => {
				if (error.name === "SyntaxError") {
					return {};
				}

				return defaultError();
			});
	};
}

export function updateInvitationAPI(data: object, challengeSlug: string, profileSlug: string, accessToken: string) {
	return function () {
		return fetch(URL_PATCH_INVITATION(challengeSlug, profileSlug), getPatchHeaderWithCredentials(data, accessToken))
			.then((response) => response.json())
			.catch((error) => {
				if (error.name === "SyntaxError") {
					return {};
				}

				return defaultError();
			});
	};
}

export function updateChallengeInstitutionConfig(data: object, accessToken: string) {
	return function () {
		return fetch(URL_PATCH_CHALLENGUE_INSTITUTION_CONFIG, getPatchHeaderWithCredentials(data, accessToken))
			.then((response) => response.json())
			.catch((error) => {
				if (error.name === "SyntaxError") {
					return {};
				}

				return defaultError();
			});
	};
}

export function updateChallengeCompanyConfig(data: object, accessToken: string) {
	return function () {
		return fetch(URL_PATCH_CHALLENGUE_COMPANY_CONFIG, getPatchHeaderWithCredentials(data, accessToken))
			.then((response) => response.json())
			.catch((error) => {
				if (error.name === "SyntaxError") {
					return {};
				}

				return defaultError();
			});
	};
}

export function getChallengeForInvestorChallengeConfigAPI(id: string, accessToken: string = "") {
	return function () {
		return fetch(URL_GET_GET_CONFIG_FOR_INVESTOR_CHALLENGUE(id), getGetHeaderWithCredentials(accessToken))
			.then((response) => response.json())
			.catch((error) => {
				if (error.name === "SyntaxError") {
					return {};
				}

				return defaultError();
			});
	};
}

export function updateChallengeIncubatorConfigAPI(data: object, accessToken: string) {
	return function () {
		return fetch(URL_PATCH_CHALLENGUE_INCUBATOR_CONFIG, getPatchHeaderWithCredentials(data, accessToken))
			.then((response) => response.json())
			.catch((error) => {
				if (error.name === "SyntaxError") {
					return {};
				}

				return defaultError();
			});
	};
}

export function updateChallengeAcceleratorConfigAPI(data: object, accessToken: string) {
	return function () {
		return fetch(URL_PATCH_CHALLENGUE_ACCELERATOR_CONFIG, getPatchHeaderWithCredentials(data, accessToken))
			.then((response) => response.json())
			.catch((error) => {
				if (error.name === "SyntaxError") {
					return {};
				}

				return defaultError();
			});
	};
}

export function addAdviserForChallengeAPI(
	challengeSlug: string,
	profileSlug: string,
	adviserSlug: string,
	accessToken: string,
) {
	return function () {
		return fetch(
			URL_PATCH_ADD_ADVISER_TO_CHALLENGUE(challengeSlug, profileSlug, adviserSlug),
			getPatchHeaderWithCredentials({}, accessToken),
		)
			.then((response) => response.json())
			.catch((error) => {
				if (error.name === "SyntaxError") {
					return {};
				}

				return defaultError();
			});
	};
}

export function deleteChallengeAPI(slug: string, accessToken: string) {
	return function () {
		return fetch(URL_DELETE_CHALLENGUE(slug), getDeleteHeaderWithCredentials(accessToken))
			.then((response) => response.json())
			.catch((error) => {
				if (error.name === "SyntaxError") {
					return {};
				}

				return defaultError();
			});
	};
}

export function deleteInvitationAPI(data: object, slug: string, profileSlug: string, accessToken: string) {
	return function () {
		return fetch(URL_DELETE_INVITATION(slug, profileSlug), getPatchHeaderWithCredentials(data, accessToken))
			.then((response) => response.json())
			.catch((error) => {
				if (error.name === "SyntaxError") {
					return {};
				}

				return defaultError();
			});
	};
}

export function deleteAdviserFromChallengeAPI(
	data: object,
	challengeSlug: string,
	profileSlug: string,
	adviserSlug: string,
	accessToken: string,
) {
	return function () {
		return fetch(
			URL_DELETE_ADVISER_TO_CHALLENGUE(challengeSlug, profileSlug, adviserSlug),
			getPatchHeaderWithCredentials(data, accessToken),
		)
			.then((response) => response.json())
			.catch((error) => {
				if (error.name === "SyntaxError") {
					return {};
				}

				return defaultError();
			});
	};
}
